import { createSlice } from "@reduxjs/toolkit";

import { getUsers, addNewUser, deleteUser, updateUser } from "./thunk";

interface ContactsStateType {
  users: Array<any>,
  userProfile: object,
  error?: string | object | null | undefined | unknown,
}
export const initialState: ContactsStateType = {
  users: [],
  userProfile: {},
  error: ''
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUsers.fulfilled, (state : any, action : any) => {
      state.users = action.payload;
    })
    builder.addCase(getUsers.rejected, (state, action) => {
      state.error = action.payload || null;
    })
    builder.addCase(addNewUser.fulfilled, (state : any, action : any) => {
      state.users.push(action.payload);
    })
    builder.addCase(addNewUser.rejected, (state, action) => {
      state.error = action.payload || null;
    })
    builder.addCase(deleteUser.fulfilled, (state: any, action: any) => {
      if (state.users && state.users.data && Array.isArray(state.users.data)) {
        state.users.data = state.users.data.filter((event: any) => event['users_id'] + '' !== action.payload + '');
      } else if (Array.isArray(state.users)) {
        state.users = state.users.filter((event: any) => event['users_id'] + '' !== action.payload + '');
      }
    })
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.error = action.payload || null;
    })
    builder.addCase(updateUser.fulfilled, (state: any, action: any) => {
      const updatedUser = action.payload.user;
      // Check if users is the new paginated structure
      if (state.users && state.users.data && Array.isArray(state.users.data)) {
        state.users.data = state.users.data.map((event: any) =>
          event?.users_id + '' === updatedUser?.users_id + ''
            ? { ...event, ...updatedUser }
            : event
        );
      } else if (Array.isArray(state.users)) {
        // Fallback for old structure
        state.users = state.users.map((event: any) =>
          event?.users_id + '' === updatedUser?.users_id + ''
            ? { ...event, ...updatedUser }
            : event
        );
      }
    })
    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = action.payload || null;
    })
  },
});

export default contactsSlice.reducer;
